import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { Empty, Spin } from 'antd';
import InfoCard from '../../../../../components/common/InfoCard/InfoCard';
import AddTenantModal from '../../../../../components/ui/modals/AddTenantModal/AddTenantModal';
import useChangeModalVisible from '../../../../../../../hooks/useChangeModalVisible';
import useCurrentAddress from '../../../../../hooks/useCurrentAddress';
import { texts } from '../../../../../constants/texts';
import useFlatsGridState from '../../../../../hooks/useFlatsGridState';
import useHousingStockState from '../../../../../hooks/useHousingStockState';
import styles from '../Flat.module.scss';
import TenantCardGeneral from '../../../../../components/ui/TenantCardGeneral/TenantCardGeneral';

const FlatTenants = () => {
  const currentFlat = useSelector(
    (state) => state.housingStockStore.currentFlat
  );

  const [currentTenant, setCurrentTenant] = useState(null);

  const {
    visible: addTenantModalVisible,
    showModal: showAddTenantModal,
    hideModal: hideAddTenantModal,
  } = useChangeModalVisible();

  const handleChangeButtonClick = (tenant) => {
    showAddTenantModal();
    setCurrentTenant(tenant);
  };

  const handleCancel = () => {
    setCurrentTenant(null);
    hideAddTenantModal();
  };

  useEffect(() => {
    if (currentTenant) {
      const updatedTenant = currentFlat?.clients.find(
        (t) => t.id === currentTenant.id
      );
      if (updatedTenant && updatedTenant !== currentTenant) {
        setCurrentTenant(updatedTenant);
      }
    }
  }, [currentFlat?.clients]);

  const address = useCurrentAddress();

  const { flatsGridQueryKey, flatsGridState } = useFlatsGridState();
  const { housingStockQueryKey } = useHousingStockState();

  return (
    <Spin
      spinning={flatsGridState?.isFetching}
      wrapperClassName={styles.spin}
    >
      {currentFlat?.clients.length ? (
        <>
          {currentFlat.clients.map((client, index) => (
            <TenantCardGeneral
              key={index}
              tenant={client}
              className={styles.card}
              style={{ backgroundColor: '#f3f7fc' }}
              bgColorElement="white"
              onChangeButtonClick={() => handleChangeButtonClick(client)}
              addressId={currentFlat?.addressId}
            />
          ))}
          <AddTenantModal
            visible={addTenantModalVisible}
            onCancel={handleCancel}
            address={address}
            addressId={currentFlat?.addressId}
            initialValues={currentTenant}
            queryKeys={[flatsGridQueryKey, housingStockQueryKey]}
          />
        </>
      ) : (
        <InfoCard
          title="Жители"
          className={styles.grow}
        >
          <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} />
        </InfoCard>
      )}
    </Spin>
  );
};

export default FlatTenants;
